import { operatorClient } from 'domain/HttpClients';

const ROOT_API = '/api/finance/credit-terms';

export const fetch = (filters = {}) => operatorClient
  .Get(ROOT_API)
  .withParams(filters)
  .send();

export const revoke = (id) => operatorClient.Delete(`${ROOT_API}/${id}`).send();

export const replenish = (id, data) => operatorClient
  .Put(`${ROOT_API}/${id}`)
  .withData(data)
  .send();

export const create = (data) => operatorClient
  .Post(ROOT_API)
  .withData(data)
  .send();

export const invoiceCreate = (id) => operatorClient
  .Post(`${ROOT_API}/invoices`)
  .withParams({ termsId: id })
  .send();
